// vendor libraries:

// our stuff:
import { reactRender } from './reactRender';
import { createDivElement } from './utils';
import { createMessageBoxComponent, MessageBoxDlgTypeButtonsMap, MessageBoxTypes } from '../components/MessageBox';

export function messageBox<T extends MessageBoxTypes = 'ok'>(header: string, message: string, callback?: (btn: MessageBoxDlgTypeButtonsMap[T]) => void, type?: T, timeout?: number) {
    let container = document.querySelector("body > .messagebox-react");
    if (container)
        container.remove() // to unmount reactRoot
        /*ReactDOM.unmountComponentAtNode(container);
    else*/
    container = createDivElement(document.body, "messagebox-react");

    const msg = createMessageBoxComponent<T>(header, message, callback, type, timeout);
    reactRender(msg, container);
}
/*
export function messageBoxAsync<T extends MessageBoxTypes = 'ok'>(header: string, message: string, type?: T, timeout?: number): Promise<MessageBoxDlgTypeButtonsMap[T] > {
    return new Promise((resolve) => {
        messageBox(header, message, btn => resolve(btn), type, timeout);
    });
}
*/
